import { Box, Button, Typography } from '@mui/material';
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleGoBack() {
        if (window.history.length > 1) {
            window.history.back();
            setTimeout(() => {
                window.location.reload();
            }, 100);
        } else {
            window.location.href = '/';
        }
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    minHeight="100vh"
                    textAlign="center"
                    p={3}
                >
                    <Typography variant="h4" gutterBottom>
                        Something went wrong
                    </Typography>
                    <Typography variant="body1" color="text.secondary" mb={3}>
                        An unexpected error occurred. Please try going back and refreshing the page.
                    </Typography>
                    <Button variant="contained" color="primary" onClick={() => this.handleGoBack()}>
                        Go Back
                    </Button>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
